<template>
	<b-table
			:checkable="checkable"
			:loading="isLoading"
			:paginated="false"
			:striped="true"
			:hoverable="true"
			default-sort="date"
			:data='data'
			>

		<template slot-scope="props">
			<b-table-column label="日程" field="date" sortable>
				{{ props.row.date }}
			</b-table-column>
			<b-table-column label="開始" field="schedule_start" sortable>
				{{ props.row.schedule_start }}
			</b-table-column>
			<b-table-column label="終了" field="schedule_end" sortable>
				{{ props.row.schedule_end }}
			</b-table-column>
			<b-table-column label="店舗" field="shop" sortable>
				{{ props.row.shop }}
			</b-table-column>
			<b-table-column label="ディレクター" field="is_director" centered>
				<b-icon type="is-success" icon="check" v-if="props.row.is_director"></b-icon>
			</b-table-column>
			<b-table-column label="スタッフ" field="staff_name" sortable>
				{{ props.row.staff_name }}
			</b-table-column>
			<b-table-column label=" ">
				<div class="buttons is-right">
					<button class="button is-small is-warning" type="button" @click="onEditButtonClick(props.row.id)">編集</button>
					<button class="button is-small is-danger ml-10" type="button" @click="onDeleteButtonClick(props.row.id)">削除</button>
				</div>
			</b-table-column>
		</template>

		<section class="section" slot="empty">
			<div class="content has-text-grey has-text-centered">
				<template v-if="isLoading">
				</template>
				<template v-else>
					<p>データはありません</p>
				</template>
			</div>
		</section>
	</b-table>
</template>

<script>
export default {
	name: "ScheduleTable",
	props: {
		data: {
			type: Array,
			default: [],
		},
		checkable: {
			type: Boolean,
			default: false,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	methods: {
		onEditButtonClick: function(id) {
			this.$emit('schedule-edit-buton-click', id);
		},
		onDeleteButtonClick: function(id) {
			this.$emit('schedule-delete-buton-click', id);
		},
	},
}
</script>

<style scoped>

</style>
